import React, { useEffect, useState } from "react";
import './inscriptionScreen.css'
import StapeForm from "../../components/stapeForm/stapeForm";

import PageCreation from "./page/pageCreation";
import PageInfo from "./page/pageInfo";
import PagePayement from "./page/pagePayement";
import QWhite from '../../image/logo/QWhite.svg'
import logoWhite from '../../image/logo/logoWhite.svg'
import { FiChevronRight } from "react-icons/fi";
const formatPhoneFR = (raw: string) => {
  if (!raw) return '';
  const cleaned = raw.replace(/[^\d+]/g, '');
  let digits = cleaned;
  if (digits.startsWith('+33')) digits = '0' + digits.slice(3);
  digits = digits.replace(/\D/g, '');
  return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
};

const InscriptionScreen = () => {
    const [complete,setComplete] = useState<boolean[]>([false,false,false])
    const token = new URLSearchParams(window.location.search).get('token') || '';
    const [currentStape,setCurrentStape] = useState(0)
    
    const [startName,setStartName] = useState('')
    const [startfirstName,setStartFirstName] = useState('')
    const [startMail,setStartMail] = useState('')
    const [startBirth,setStartBirth] = useState<[string,string,string]>(['','',''])

    const [startNewsletter, setStartNewsletter] = useState(false);

    const [tokenEmail, setTokenEmail] = useState('');
    const [emailVerifiedStart,setEmailVerifiedStart] = useState(false)
    const [emailAvailable,setEmailAvailable] = useState(false)

    const [startLat, setStartLat] = useState(0);
    const [startLng, setStartLng] = useState(0);

    const [nameResto,setNameResto] = useState('')
    const [address,setAddress] = useState('')
    const [postalCode,setPostalCode] = useState(0)
    const [city,setCity] = useState('')
    const [phone, setPhone] = useState('');
    



    const setNewCurrentStape = (id:number) => {
        setCurrentStape(id)
        setComplete(prevComplete => 
            prevComplete.map((_, index) => index < id)
        );
    }

    const validPage = (id:number) => {
        setCurrentStape(id+1)
        setComplete(prevComplete => 
            prevComplete.map((_, index) => index <= id)
        );
    }
    useEffect(() => {
        const getStart = async () => { 
            
            if(token) {
                const response = await  fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getStartInscription`, { 
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token: token }),
                });
                const data = await response.json();

                if (data.success) {
                    const tmp = data.data || {};
                    const pf = data.prefill || {};

                    const tokenEmail = (data.email || '').trim().toLowerCase();
                    const tmpEmail = (tmp.email || '').trim().toLowerCase();
                    const chosenEmail = tmpEmail || tokenEmail; 


                    setStartName(tmp.name || '');
                    setStartFirstName(tmp.firstname || '')
                    setStartMail(chosenEmail);
                    setTokenEmail(chosenEmail)
                    setPostalCode(tmp.postal_code || pf.postal_code || 0);
                    setEmailAvailable(data.emailAvailable)

                    if(tmp.birth_date) {
                        let dateBirth = new Date(tmp.birth_date) 
                        setStartBirth([
                            String(dateBirth.getDate()).padStart(2,'0'),
                            String(dateBirth.getMonth() + 1).padStart(2,'0'),
                            String(dateBirth.getFullYear())
                        ]);
                    }
                    
                    setNameResto(tmp.namer || pf.name || '');
                    setStartNewsletter(tmp.newsletter);
                    setAddress(tmp.address || pf.address?.[0] || '');
                    setCity(tmp.city || pf.address?.[1] || '');
                    const phoneChosen = tmp.phone || pf.phone || '';
                    setPhone(tmp.phone ? phoneChosen : formatPhoneFR(phoneChosen));
                    setStartLat(tmp.lat || pf.latitude || 0);
                    setStartLng(tmp.lng || pf.longitude || 0);

                    if (data.code === 'complete') {
                        validPage(1); 
                    } else if (data.code === 'partial') {
                        validPage(0);
                    }
                } 
            }
        }
        getStart()
    },[])

    const handleClickArian = (index:number) => {
        if(currentStape > index) {
            setNewCurrentStape(index)
        }
    }

    useEffect(() => {
        const mail = (startMail || '').trim().toLowerCase();
        setEmailVerifiedStart(Boolean(tokenEmail) && mail === tokenEmail);
    }, [startMail, tokenEmail]);
    

    return (
        <div className='containerInscription primaryBack'>
            <div className="topBar">
                <img src={QWhite}  className="logoPhone" loading="lazy" alt="logo"/>
                <img src={logoWhite} className="logo" loading="lazy" alt="logo"/>
                <p className="largerTitle">Créer mon compte</p>
            </div>
            <div className="headBar">
                    <StapeForm name={"Informations personnelles"}   index={0} currentStape={currentStape} setNewCurrentStape={setNewCurrentStape} complete={complete[0]}/>
                    <div  className="separation"></div>
                    <StapeForm name={"Informations de votre restaurant"}   index={1} currentStape={currentStape} setNewCurrentStape={setNewCurrentStape} complete={complete[1]}/>
                    <div  className="separation"></div>
                    <StapeForm name={"Paiement"}   index={2} currentStape={currentStape} setNewCurrentStape={setNewCurrentStape} complete={complete[2]}/>
            </div>
            <div className="arianWire XsmallText">
                <p onClick={() => handleClickArian(0)} >Informations personnelles</p>
                <FiChevronRight size={10} className="separation"/>
                <p onClick={() => handleClickArian(1)} className={`${currentStape < 1 && 'locked'}`}>Informations de votre restaurant</p>
                <FiChevronRight size={10} className="separation"/>
                <p onClick={() => handleClickArian(2)} className={`${currentStape < 2 && 'locked'}`}>Paiement</p>
            </div>
            <div className="headBarPhone">
                <StapeForm name={`${currentStape === 0 ? 'Informations personnelles' : (currentStape === 1 ? "Informations de votre restaurant" : "Paiement") } `}   index={currentStape} currentStape={currentStape} setNewCurrentStape={setNewCurrentStape} complete={false}/>
            </div>
            <div className="borderBottomBar"></div>
            <div className="mainCorp">
                {
                    currentStape === 0 ?
                        <PageInfo validPage={validPage} token={token} emailAvailable={emailAvailable} emailVerifiedStart={emailVerifiedStart} namestart={startName} setNameStart={setStartName} mailStart={startMail} setMailStart={setStartMail} firstNamestart={startfirstName} setFirstNameStart={setStartFirstName} birthStart={startBirth} setBirthStart={setStartBirth}/>
                        : currentStape === 1 ?
                            <PageCreation validPage={validPage} token={token} nameResto={nameResto} setNameResto={setNameResto} newsletterStart={startNewsletter} postalCode={postalCode} setPostalCode={setPostalCode} address={address} setAddress={setAddress} city={city} setCity={setCity} phone={phone} setPhone={setPhone}  latStart={startLat} lngStart={startLng}/>
                            : <PagePayement validPage={validPage} token={token} cityStart={city} postalCodeStart={postalCode} emailStart={startMail} addressStart={address} firstnameStart={startfirstName} lastnameStart={startName} phoneStart={phone} denominationStart={nameResto}/>
                }

            </div>
        </div>
    )
}

export default InscriptionScreen